/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { getUsageTracker } from '../clients/usageTracker';
import { getUsageTrackingProperties } from '../selectors/getUsageTrackingProperties';
export const setUsageTrackingProperties = store => next => action => {
  getUsageTracker().setProperties(getUsageTrackingProperties(store.getState()));
  return next(action);
};